var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransposeOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.333 7.5V3C12.333 1.89543 11.4376 1 10.333 1L3.00001 1C1.89544 1 1.00001 1.89543 1.00001 3V7.5C1.00001 8.60457 1.89544 9.5 3.00001 9.5H10.333C11.4376 9.5 12.333 8.60457 12.333 7.5Z",
    fill: "#272C55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.833 7.5V3C11.833 2.17157 11.1614 1.5 10.333 1.5L3.00001 1.5C2.17158 1.5 1.50001 2.17157 1.50001 3V7.5C1.50001 8.32843 2.17158 9 3.00001 9H10.333C11.1614 9 11.833 8.32843 11.833 7.5Z",
    stroke: "#272C55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 1.47266V9.02866",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8613 4.11719L1.47233 4.11719",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8613 6.94922L1.47233 6.94922",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10H15C13.8954 10 13 10.8954 13 12V19C13 20.1046 13.8954 21 15 21H19C20.1046 21 21 20.1046 21 19V12C21 10.8954 20.1046 10 19 10Z",
    fill: "#272C55"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10.5H15C14.1716 10.5 13.5 11.1716 13.5 12V19C13.5 19.8284 14.1716 20.5 15 20.5H19C19.8284 20.5 20.5 19.8284 20.5 19V12C20.5 11.1716 19.8284 10.5 19 10.5Z",
    stroke: "#272C55"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.458 13.668H20.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.458 17.332H20.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.125 10.457V20.54",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11.5V15.5",
    stroke: "#272C55",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 15.5H10.5",
    stroke: "#272C55",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 13.5L11.5 15.5",
    stroke: "#272C55",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17.5L11.5 15.5",
    stroke: "#272C55",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransposeOperationIcon);
export default __webpack_public_path__ + "static/media/TransposeOperationIcon.98aeab5f4a408c8e38fac353e6e6ccf3.svg";
export { ForwardRef as ReactComponent };